import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Module from '../../../templates/components/Module'
import SideTabs from '../../../templates/layouts/SideTabs'
import FindAllInvoices from '../invoices/find-all-invoices/FindAllInvoices'
import PaymentPlanList from '../report/paymentPlan-list/PaymentPlanList'
import FindAllTransactionsList from '../transactions/find-all-transactions/FindAllTransactionsList'
import { store } from "../../../../context/StateProvider";

const PaymentDashboard = (props) => {
    const [activeTab, setActiveTab] = useState()
    const globalStateAndDispatch = useContext(store);
    const contextState = globalStateAndDispatch.state;
    const navigate = useNavigate()
    useEffect(() => {
        changeTab(props.tab)
    }, [props.tab])
    const changeTab = (tab) => {
        if (tab === 'invoices') {
            navigate('/provider/payments')
            setActiveTab(tab)
        }
        else {
            navigate(`/provider/payments/${tab}`)
            setActiveTab(tab)
        }
    }
    return (
        //initial state is set as permissions: {unset:""},
        <> {contextState.permissions["unset"]!=="" && <SideTabs title="Payment Dashboard" menuTitle="Payment Menu" activeKey={activeTab} onSelect={k => changeTab(k)}>
            {contextState.permissions.paymentsViewInvoices &&
            <Module title="Invoices" eventKey="invoices">
                <FindAllInvoices title="Invoices" />
            </Module>
            }
            {contextState.permissions.paymentsViewTransactions &&
            <Module title="Transactions" eventKey="transactions">
                <FindAllTransactionsList title="Transactions" />
            </Module>
            }
            {contextState.permissions.paymentsViewSubscriptionsAndPlans &&
            <Module title="Subscriptions" eventKey="subscriptions">
            <PaymentPlanList type={3} />
            </Module>
            }
            {contextState.permissions.paymentsViewSubscriptionsAndPlans &&
                <Module title="Payment Plans" eventKey="paymentplans">
                <PaymentPlanList type={1} />
            </Module>
            }
        </SideTabs>}</>
    )
}

export default PaymentDashboard